var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGif = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 7C13 7 12 6 12 4V1H6C4 1 3 2 3 4V16C3 18 4 19 6 19H15C17 19 18 18 18 16V7H15Z",
    fill: "#4D6EF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7H18L12 1V4C12 6 13 7 15 7Z",
    fill: "#4D6EF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13125 12.6002C9.06792 12.4835 8.97625 12.3952 8.85625 12.3352C8.73958 12.2719 8.60125 12.2402 8.44125 12.2402C8.16458 12.2402 7.94292 12.3319 7.77625 12.5152C7.60958 12.6952 7.52625 12.9369 7.52625 13.2402C7.52625 13.5635 7.61292 13.8169 7.78625 14.0002C7.96292 14.1802 8.20458 14.2702 8.51125 14.2702C8.72125 14.2702 8.89792 14.2169 9.04125 14.1102C9.18792 14.0035 9.29458 13.8502 9.36125 13.6502H8.27625V13.0202H10.1363V13.8152C10.0729 14.0285 9.96458 14.2269 9.81125 14.4102C9.66125 14.5935 9.46958 14.7419 9.23625 14.8552C9.00292 14.9685 8.73958 15.0252 8.44625 15.0252C8.09958 15.0252 7.78958 14.9502 7.51625 14.8002C7.24625 14.6469 7.03458 14.4352 6.88125 14.1652C6.73125 13.8952 6.65625 13.5869 6.65625 13.2402C6.65625 12.8935 6.73125 12.5852 6.88125 12.3152C7.03458 12.0419 7.24625 11.8302 7.51625 11.6802C7.78625 11.5269 8.09458 11.4502 8.44125 11.4502C8.86125 11.4502 9.21458 11.5519 9.50125 11.7552C9.79125 11.9585 9.98292 12.2402 10.0763 12.6002H9.13125Z",
    fill: "#4D6EF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4648 11.4902V15.0002H10.6098V11.4902H11.4648Z",
    fill: "#4D6EF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3695 11.4902V12.1752H12.9395V12.9152H14.0095V13.5802H12.9395V15.0002H12.0845V11.4902H14.3695Z",
    fill: "#4D6EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGif);
export default ForwardRef;